import qwest from 'qwest';

import Pool from '../models/pool.jsx';

import customerApi from './customer.jsx';

import session from './../services/sessionService.jsx';

let PoolApi = {
  getPool(id, forceNew = false) {
    return new Promise((resolve, reject) => {
      let pool = session.getPool(id);

      if (pool && !forceNew) {
        resolve(pool);
      } else {
        qwest.get(`/Pool?id=${id}`)
          .then((xhr, response) => {
            if (response.success) {
              pool = Pool.fromApiFormat(response.data);
              session.setPool(id, pool);
              resolve(pool);
            } else {
              reject(response);
            }
          });
      }
    });
  },

  getList(customerID) {
    return new Promise((resolve, reject) => {
      qwest.get(`/Pool/List?customerID=${customerID}`)
      .then((xhr, response) => {
        if (response.success) {
          let pools = response.data.map(p => Pool.fromApiFormat(p));

          resolve(pools);
        } else {
          reject(response);
        }
      });
    });
  },

  savePool(pool) {
    return new Promise((resolve, reject) => {
      qwest.post('/Pool', pool.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            let newPool = Pool.fromApiFormat(response.data);

            session.setPool(newPool.id, newPool);
            customerApi.getCustomer(newPool.customerID, true); // Updates customer so pool summary + source concern is now accurate.
            resolve(newPool);
          } else {
            reject(response);
          }
        });
    });
  },

  deletePool(pool) {
    return new Promise((resolve, reject) => {
      qwest.delete('/Pool', pool.toApiFormat())
        .then((xhr, response) => {
          if (response.success) {
            customerApi.getCustomer(pool.customerID, true);
            session.deletePool(pool);
            resolve(response);
          } else {
            reject(response);
          }
        });
    });
  },

  saveAll(customerID, pools) {
    return qwest.post('/Pool/SaveAll', {
      pools: pools.map(x => x.toApiFormat()),
      customerID,
    }).then((xhr, res) => res);
  },
};

export default PoolApi;
